import {getDateString} from "./Utils";
import LocationCode from "./constants/LocationCode";

let UserEditInfo = {
    labels: ["이름", "수강 지점", "생년월일", "주소", "이메일",
        "아이디", "장르", "경력", "비밀번호", "등록 일자", "문자수신 여부"],
    dataName: ["name", "location", "birth", "address", "email",
        "loginid", "genre", "ability", "password", "registration", "subscribed"],
    getDataString: function (dataName, data) {
        switch (dataName) {
            case "location":
                return LocationCode.text[data]
            case "birth":
            case "registration":
                return getDateString(new Date(data))
            default:
                return data;
        }
    },
    getInputName: function (s) {
        return "user-input-" + s
    },
    getInvalidMessageId: function (s) {
        return "user-input-invalid-" + s
    },
    editables: ["email", "loginid", "password", "subscribed"],
    editableTextInputs: ["email", "loginid"],
    editableTextRegex: ["[\\w.]+@[\\w]+\\.[\\w]+", "\\w+"],
    editableTextLimits: [38, 40, 6, 20],
    invalidMessages: {
        NO_INPUT: "입력되지 않았습니다",
        INVALID_LOGINID: "영어, 숫자만 가능합니다.",
        INVALID_EMAIL: "잘못된 이메일 형식입니다.",
    },
    editRequired: ["email", "loginid"],
    editInvalid: ["NO_INPUT", "INVALID_EMAIL", "INVALID_LOGINID"]
}
export default UserEditInfo